import api from './api';

// Project service for API communication
const projectService = {
  // Get all projects with optional filters
  getProjects: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.include_disabled !== undefined) {
        // Convert boolean to 1/0 for Laravel's boolean validation
        params.append('include_disabled', filters.include_disabled ? 1 : 0);
      }

      const queryString = params.toString();
      const url = queryString ? `/api/projects?${queryString}` : '/api/projects';

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get a specific project
  getProject: async (id) => {
    try {
      const response = await api.get(`/api/projects/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create a new project
  createProject: async (projectData) => {
    try {
      const response = await api.post('/api/projects', projectData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update an existing project
  updateProject: async (id, projectData) => {
    try {
      const response = await api.put(`/api/projects/${id}`, projectData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete a project
  deleteProject: async (id) => {
    try {
      const response = await api.delete(`/api/projects/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get available agents
  getAvailableAgents: async () => {
    try {
      const response = await api.get('/api/projects/agents/available');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default projectService;